import { TableFieldModel } from '@/model/TableList'
import $currency from 'currency.js'

export const maxMinCalc = (rowData: any, type: string) => {
  const {
    rate = 0,
    invoiceType,
    fee
  } = rowData[type] || {}
  if (!fee) {
    return ''
  }
  if (rate && invoiceType) {
    return `${$currency(fee)}含${rate}%的${invoiceType}`
  }
  return `${$currency(fee)}`
}

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '物料编号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '名称'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'num',
    fieldName: '数量'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createUserName',
    fieldName: '申请人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialClass',
    fieldName: '物料类别',
    width: 120
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'materialUnit',
    fieldName: '物料单位',
    width: 120
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'standard',
    fieldName: '封装规格',
    width: 120
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'brand',
    fieldName: '品牌',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'model',
    fieldName: '型号',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'code',
    fieldName: '代码'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'parameter',
    fieldName: '参数'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'device',
    fieldName: '使用设备'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'statusValue',
    fieldName: '状态'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'purchaseStatusValue',
    fieldName: '采购状态'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'location',
    fieldName: '位置',
    convert: context => context.rowData.location?.location
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'approveUserName',
    fieldName: '出库确认人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'createTime',
    fieldName: '创建时间'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'approveTime',
    fieldName: '出库确认时间'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'backUserName',
    fieldName: '归还确认人'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'backTime',
    fieldName: '归还确认时间'
  }
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'max',
  //   fieldName: '最高价',
  //   convert: context => {
  //     const { rowData } = context
  //     return maxMinCalc(rowData, 'max')
  //   }
  // },
  // {
  //   componentType: 'el-input',
  //   componentName: '输入框',
  //   fieldKey: 'min',
  //   fieldName: '最低价',
  //   convert: context => {
  //     const { rowData } = context
  //     return maxMinCalc(rowData, 'min')
  //   }
  // }
]
